export const housekeeping = {
  // ── Page (index) ──
  title: "Housekeeping",
  remindersBtn: "Reminders",
  refresh: "Refresh",
  aboutToLeaveTitle: "Guests about to leave today",
  aboutToLeaveCount: "{count} about to leave",
  remindersTitle: "Configure cleaning reminders",

  headline: {
    allDone: "All caught up! Nothing to clean right now.",
    inProgress: "Cleaning underway · {count} in progress",
    toClean: "What needs cleaning today? {count} to clean",
    toCleanWithProgress: "What needs cleaning today? {toClean} to clean · {inProgress} in progress",
  },

  allProperties: "All properties",
  searchPlaceholder: "Search room, guest…",

  // Status filter chips (label)
  chips: {
    all: "All",
    to_clean: "To clean",
    in_progress: "In progress",
    occupied: "Occupied",
    clean: "Available",
    out_of_service: "Out of service",
  },
  // Status filter chips (tooltip)
  chipTips: {
    all: "All of today's spaces, unfiltered.",
    to_clean: "Pending cleaning: marked dirty, departing today and not cleaned, or long stays due per their interval.",
    in_progress: "Cleaning underway right now.",
    occupied: "Guest inside (stay in progress, not leaving today).",
    clean: "Clean and ready for the next guest (includes inspected ones).",
    out_of_service: "Not available to clean (fault or maintenance).",
  },

  loadingBoard: "Loading board…",
  emptyToClean: "All clean! No pending spaces right now.",
  emptyStatus: "No spaces in this status.",
  emptySearch: "No spaces match your search.",

  typeHotel: "Hotel",
  typeApartment: "Apartment",

  // Row badges
  stayDue: "Cleaning due",
  hourlyStayDue: "Hourly stay ended",
  hourlyStayAt: "Left at {time}",
  overdue: "Overdue",
  overdueSince: "Not cleaned since {date} · {days} days",
  overdueGuests: "{n} guests have left with no cleaning on record",
  // La franja de una estancia por horas en marcha, en la fila del tablero.
  hourlyInUse: "From {from} to {to}",
  // El cliente sigue dentro y su hora de fin ya pasó.
  hourlyOverdue: "Past due time",
  alreadyLeft: "Already left",
  aboutToLeave: "About to leave",
  cleanBadge: "Clean",
  inspectedBadge: "Inspected",

  // Turnover (one leaves / another arrives)
  departs: "↑ Out",
  arrives: "↓ In",
  guestFallback: "Guest",
  departsOn: "· leaves {date}",

  // Row actions
  assign: "Assign",
  reassignTitle: "Reassign who cleans",
  assignWhoTitle: "Assign who cleans",
  start: "Start",
  startTitle: "Mark in progress",
  cleanAction: "Clean",
  cleanTitle: "Complete cleaning (photos and notes)",
  tasks: "Tasks",
  tasksTitle: "Tasks and details",

  toastSaved: "Cleaning reminders updated",

  // Effective status (label)
  status: {
    to_clean: "To clean",
    in_progress: "In progress",
    occupied: "In use",
    clean: "Available",
    inspected: "Inspected",
    out_of_service: "Out of service",
  },
  // Effective status (tooltip)
  statusTip: {
    to_clean: "Waiting to be cleaned.",
    in_progress: "Cleaning underway.",
    occupied: "In use: guest inside.",
    clean: "Clean and ready for the next guest.",
    inspected: "Clean and verified by a supervisor.",
    out_of_service: "Out of service: can't be cleaned (fault/maintenance).",
  },
  // Occupancy (label)
  occupancy: {
    vacant: "Vacant",
    occupied: "Occupied",
    departure_today: "Departs today",
    arrival_today: "Arrives today",
    turnover: "Departure and arrival",
  },
  // Occupancy (tooltip)
  occupancyTip: {
    vacant: "No guest: free.",
    occupied: "Guest inside (stay in progress).",
    departure_today: "Guest departs today: will need cleaning.",
    arrival_today: "A guest arrives today: must be ready in time.",
    turnover: "One guest leaves and another arrives today: urgent cleaning in between.",
  },

  roles: {
    limpieza: "Cleaning",
    mantenimiento: "Maintenance",
    recepcion: "Reception",
    gestor: "Manager",
    propietario: "Owner",
  },

  // Mid-stay cleaning reason
  stayTip: {
    fallback: "Stay cleaning due",
    daysSince: "{count} day | {count} days",
    interval: "every day | every {count} days",
    main: "The guest is still staying. It's been {since} without cleaning and is due {interval}.",
  },

  // Cleaning-window timer
  timer: {
    approx: " (approx.)",
    overdue: "Arrival overdue",
    overdueTitle: "The arrival time ({checkin}) has passed · prioritize this cleaning",
    remaining: "{dur} to arrival",
    remainingTitle: "{dur} left until arrival ({checkin})",
  },

  // ── Reminders modal ──
  remind: {
    title: "Cleaning reminders",
    subtitle: "Alert your team when a room with an upcoming arrival/departure isn't ready.",
    close: "Close",
    scopeLabel: "Which properties?",
    scopeOne: "This property",
    scopeAll: "All",
    summary: "{enabled} of {total} properties with reminders active.",
    propertyLabel: "Property",
    activeSuffix: " · active",
    propertyHelp: "Each property keeps its own schedule.",
    allNotePre: "The same settings will apply to your ",
    allNotePost: " properties (each in its local time).",
    arrivalsTitle: "Arrivals and departures",
    longStayTitle: "Long-stay bookings",
    daysBeforeLabel: "How far in advance?",
    daysBefore: {
      same: "Same day only",
      upTo: "Up to {count} day before | Up to {count} days before",
    },
    daysBeforeHelp: "Looks at arrivals/departures within this window.",
    intervalLabel: "How many days between cleanings?",
    interval: "Every day | Every {count} days",
    intervalHelp: "Counted from the last cleaning. The room will appear under 'To clean' even while still occupied.",
    timeLabel: "What time are they sent?",
    timeHelp: "Property's local time. Once a day.",
    recipientsLabel: "Who gets notified?",
    note: "They're sent via a queue (notification + push) and every alert is logged in notifications.",
    cancel: "Cancel",
    saving: "Saving…",
    saveAll: "Save for all",
    save: "Save",
    recipients: {
      assigned: "Assigned",
      team: "Team",
      both: "Both",
    },
    recipientHelp: {
      assigned: "Only the people assigned to that room.",
      team: "The property's whole cleaning/maintenance team.",
      both: "The assignees and the property team.",
    },
    longStayOff: "Disabled",
    longStaySub: "Every day of the stay | Every {count} days of the stay",
    toggleAllOn: "Will be enabled for all",
    toggleAllOff: "Will be disabled for all",
    toggleOneOn: "Enabled for this property",
    toggleOneOff: "Disabled",
  },

  // ── Complete-cleaning modal ──
  complete: {
    title: "Complete cleaning",
    dropStrong: "Drag photos here",
    dropRest: "or click to select",
    dropHint: "Evidence of the room's condition · JPG, PNG, WEBP",
    photoAlt: "photo",
    saved: "Saved",
    view: "View",
    remove: "Remove",
    notes: "Notes",
    notesPlaceholder: "Issues, damage, missing items… (optional)",
    cancel: "Cancel",
    uploading: "Uploading… {pct}%",
    saving: "Saving…",
    submit: "Mark as clean",
    previewAlt: "preview",
  },

  // ── Assign modal ──
  assignModal: {
    title: "Who cleans this space?",
    allOption: "Everyone",
    allDesc: "Visible to all cleaning and maintenance staff",
    roleSection: "Assign to a role",
    peopleTitle: "Or pick people",
    peopleHint: "(one or more)",
    emptyPre: "You don't have any team members yet. You can assign by role, or add people in ",
    emptyTeam: "Team",
    emptyPost: ".",
    cancel: "Cancel",
    saving: "Saving…",
    save: "Save assignment",
  },

  // ── Planning: the upcoming-cleanings calendar ──
  plan: {
    title: "Cleaning schedule",
    viewToday: "Today",
    viewPlan: "Schedule",
    loading: "Loading the schedule…",
    loadError: "The schedule could not be loaded.",
    saveError: "Could not save. Please try again.",
    empty: "No cleanings in these dates.",
    space: "Space",
    prev: "Previous days",
    next: "Next days",
    today: "Today",
    days: "{n} days",
    anyone: "Anyone",
    unassigned: "Unassigned",
    headline: {
      nothing: "Nothing pending in these dates.",
      all: "{total} cleanings pending · {urgentes} urgent",
      withOrphans: "{total} pending · {urgentes} urgent · {sin} unassigned",
    },
    types: {
      turnover: "Check-out & check-in",
      arrastre: "Overdue",
      salida: "Departure",
      estancia: "Long stay",
      manual: "Marked by hand",
    },
    abbr: { all: "ALL", turnover: "TURN", arrastre: "LATE", salida: "OUT", estancia: "STAY", manual: "MAN" },
    windowGuessed: "House hours: this property has none of its own set",
    legendTight: "Tight gap between check-out and check-in",
    noRoomTip: "{n} departures with no room assigned yet",
    windowTip: "There are {min} minutes between check-out ({desde}) and check-in ({hasta})",
    roleShort: "ROLE",
    roleFull: "Assigned to a role, not to a person",
    fromSpace: "standing assignment for this space",
    nobody: "Unassigned — click to pick someone",
    dow: { mon: "M", tue: "T", wed: "W", thu: "T", fri: "F", sat: "S", sun: "S" },

    teamRows: "Team workload",

    teamTitle: "Team",
    capacity: "Capacity",
    capacityTitle: "How many cleanings each person can do per day",
    done: "Done",
    perDay: "Per day",
    dayOffTip: "Mark as day off",
    noStaff: "You don't have cleaning staff yet. Add people under Team and their workload will show here.",
    shortHands: "Short-handed: {dias}",
    loadTip: "{dia}: {n} of {cap}",
    loadTipOff: "{dia}: day off ({n} assigned)",
    hasNow: "{n} assigned · handles {cap} per day",

    selected: "{n} selected",
    assignTo: "Assign to…",
    assignBtn: "Assign {n}",
    people: "People",
    noteTitle: "Note for this cleaning",
    notePlaceholder: "Arrives late, prioritise…",
    unassign: "Remove",
    clear: "Clear selection",
    assigned: "{n} cleanings assigned",
    unassigned2: "Assignment removed",
    partial: "{n} assigned, {mal} could not be",
    autoAssign: "Auto-assign",
    nothingToAssign: "Nothing unassigned in these dates.",
    proposalTitle: "Proposed split",
    proposalSub: "{n} cleanings split up. Review it before applying.",
    proposalApply: "Apply the split",
    proposalUncovered: "{n} not covered",
    cancel: "Cancel",
    uncovered: {
      nadie_tiene_esta_propiedad: "nobody has that property assigned",
      nadie_trabaja_ese_dia: "nobody works that day",
      equipo_lleno: "the team is at its limit",
    },
    rejected: {
      espacio_ajeno: "That space doesn't belong to your account.",
      persona_ajena: "That person isn't on your team.",
      persona_sin_la_propiedad: "That person doesn't have this property assigned. Assign it under Team first.",
      rol_desconocido: "That role doesn't exist.",
      datos_incompletos: "Cleaning details are missing.",
      error_al_guardar: "Could not save.",
    },
    autoAssignN: "Split {n}",
    seeDay: "See the day",
    filtering: "Filtering by",
    showingOf: "showing {n} of {total}",
    emptyFiltered: "Nothing matches these filters. There are {total} cleanings on these dates.",
    moreFilters: "More filters",
    roomy: "Roomy",
    dense: "Compact",
    ofN: "of {n} cleanings",
    addPerson: "Add someone to the team",
    notCleaner: "Not cleaning staff, but has work assigned",
    teamCap: "{n} per day",
    teamFoot: "The workload covers the whole range; filters don't change it.",
    perDayN: "{n} per day",
    closedN: "{n} closed",
    capMax: "The maximum is {n} per day",
    rowHint: "Alt + click to select the whole row",
    daySheetTip: "Click to see the day · Alt + click to select it all",
    keysHint: "1-9 assigns · A opens · Esc clears",
    undo: "Undo",
    undone: "Assignment restored",
    tightDay: "{dia} has {n} cleanings",
    tightMore1: "and 1 more day",
    tightMoreN: "and {n} more days",
    proposalDetail: "See the split cleaning by cleaning",
    nobody2: "Nobody yet",
    warnDayOff: "{quien} is off on {dia}.",
    warnOver: "{quien} goes to {n} on {dia} and handles {cap}.",
    onDay: "{dia}: {n} + {mas} of {cap}",
    onDays: "{dias} days: {n} of {cap}",
    c: { pending: "Pending", urgent: "Urgent", tight: "Tight days", done: "Done", noRoom: "No room yet" },
    rows: {
      withWork: "with work",
      all: "all",
      help: "\"All\" also shows the spaces that need no cleaning on these dates.",
      forced: "With a filter on, only the spaces that have work are shown.",
    },
    f: {
      any: "Any",
      urgency: "Urgency",
      window: "Window",
      state: "State",
      unitType: "Space type",
      clear: "Clear filters",
    },
    urg: {
      urgente: "Someone arrives that day",
      alta: "Someone arrives the next day",
      normal: "Someone arrives in 2-3 days",
      baja: "Nobody arrives after",
    },
    holg: { amplia: "Roomy", justa: "Tight", imposible: "Not enough time" },
    estados: { pendiente: "Pending", en_curso: "In progress", hecha: "Done", fuera_de_servicio: "Out of service" },
    motivos: {
      faltan_manos: "short-handed by {n}",
      con_hora_limite: "{n} with a deadline",
      varios_edificios: "{n} different buildings",
    },
    sheet: {
      autoDay: "Split this day",
      assignAll: "Assign all {n}",
      nCleanings: "{n} cleanings",
      nUnassigned: "{n} unassigned",
      covers: "the team covers {n}",
      empty: "Nothing to clean on this day.",
    },
    tip: {
      outIn: "out · in",
      lateSold: "late check-out sold",
      earlySold: "early check-in",
      noName: "No name",
      pax: "{n} pax",
      nights: "{n} nights",
      min: "{n} min",
      h: "{h} h",
      hm: "{h} h {m}",
      stillIn: "still staying",
      freeNobody: "stays empty",
      freeNone: "someone arrives",
      freeDay1: "free for 1 day",
      freeDaysN: "free for {n} days",
      houseHours: "house hours",
      openSpace: "Space details", openSpaceHint: "Opens on the Today board, with its status, tasks and history",
      select: "Select",
      deselect: "Remove from selection",
      assignedBy: "Assigned by {quien}",
    },
  },
};
